import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  ReactNode,
} from "react";
import { useHistory } from "react-router-dom";

interface RouteUtilsContextProps {
  hasNavigated: boolean;
}

const RoutesContext = createContext<RouteUtilsContextProps | undefined>(
  undefined,
);

export const RoutesUtilsProvider = ({ children }: { children: ReactNode }) => {
  const [hasNavigated, setHasNavigated] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const unListen = history.listen(() => {
      setHasNavigated(true);
    });

    return unListen;
  }, [history]);

  return (
    <RoutesContext.Provider value={{ hasNavigated }}>
      {children}
    </RoutesContext.Provider>
  );
};

export const useRouteUtils = () => {
  const routesContext = useContext(RoutesContext);

  if (!routesContext) {
    throw new Error("useRouter must be used within a RoutesProvider");
  }

  return routesContext;
};
